<template>
  <div class="mt-4">
    <dialog-confirm ref="delete-confirm">
      <div class="text-subtitle-1">
        {{ $t('are_you_sure_you_want_to_delete_this') }}
      </div>
    </dialog-confirm>
    <h4>{{ $tc('notification_rule', 2) }}</h4>
    <v-row>
      <v-col>
        <table-pagination-controls
          :total-rows="remoteData.totalRows"
          :current-page.sync="remoteData.currentPage"
          :rows-per-page.sync="remoteData.rowsPerPage"
          @update:currentPage="refreshResults"
          @update:rowsPerPage="initiateSearch"
          :per-page-options="remoteData.pageOptions"/>
        <v-data-table
          hide-default-footer
          class="vf-table mt-2"
          :headers="tableFields"
          :items="remoteData.items"
          :server-items-length="remoteData.totalRows"
          :sort-by.sync="remoteData.sortBy"
          :sort-desc.sync="remoteData.sortDesc"
          :loading="remoteData.isBusy"
          :loading-text="$t('loading')"
          @update:sort-by="initiateSearch()"
          @update:sort-desc="initiateSearch()">

          <template #item.target="row">
            <template>
              <router-link :to="getTargetPath(row.value)">{{row.item.target_label}}</router-link>
            </template>
          </template>

          <template #item.event="row">
            <template>{{ $t(row.value) }}</template>
          </template>

          <template #item.rules="row">
            <template>{{ $t(`${eventLevel(row.item.event)}:${row.item.rules[0]}`) }}</template>
          </template>

          <template #item.delivery="row">
            <template>{{ $t(row.item.delivery[0]) }}</template>
          </template>

          <template #item.created="row">
            <if-set :value="row.item.created">
              <multi-time-display :time="row.item.created" />
            </if-set>
          </template>

          <template #item.actions="row">
            <vf-tooltip :text="$t('delete')">
              <v-btn @click="deleteItem(row.item)" color="primary" fab text small>
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </vf-tooltip>
          </template>

        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay.vue'
import TablePaginationControls from '@/components/shared/TablePaginationControls'
import DialogConfirm from '@/components/shared/DialogConfirm'
import VfTooltip from '@/components/shared/VfTooltip'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import RemoteDataTableMixin from '@/components/mixins/RemoteDataTableMixin'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'

export default {
  name: 'NotificationRuleIndex',
  components: {
    MultiTimeDisplay,
    TablePaginationControls,
    DialogConfirm,
    VfTooltip
  },
  mixins: [
    CurrentUserMixin,
    RemoteDataTableMixin,
    BrowserUtilitiesMixin
  ],
  mounted () {
    this.initiateSearch()
  },
  data () {
    return {
      model: 'NotificationRule',
      searchCriteria: {},
      tableFields: [
        {
          value: 'target',
          text: this.$tc('notification_rules_ui.target'),
          sortable: true
        },
        {
          value: 'event',
          text: this.$t('notification_rules_ui.event'),
          sortable: true
        },
        {
          value: 'rules',
          text: this.$t('notification_rules_ui.rules'),
          sortable: true
        },
        {
          value: 'delivery',
          text: this.$t('notification_rules_ui.delivery'),
          sortable: true
        },
        {
          value: 'created',
          text: this.$t('created'),
          sortable: true
        },
        {
          value: 'actions',
          text: this.$tc('action', 2)
        }
      ]
    }
  },
  methods: {
    getTargetPath (target) {
      const match = target.match(/(\w+)\((\d+)\)/)
      if (match && match[1] === 'Product') {
        return '/product/' + match[2]
      }
      return '#'
    },
    buildSearchCriteria () {
      const searchCriteria = {
        page: this.remoteData.currentPage,
        'per-page': this.remoteData.rowsPerPage
      }

      if (this.remoteData.sortBy !== null) {
        const sortDirection = this.remoteData.sortDesc ? '-' : ''
        searchCriteria.sort = `${sortDirection}${this.remoteData.sortBy}`
      }

      return searchCriteria
    },

    /**
     * @return string
     */
    eventLevel (event) {
      return event.split(':')[0]
    },

    async deleteItem(item) {
      if (await this.$refs['delete-confirm'].confirm()) {
        try {
          await item.destroy()
          await this.$store.dispatch(
            'globalMessagingModule/showSuccessFlashBanner',
            `${this.$i18n.tc('notification_rule')} ${this.$i18n.t('generic_delete_success')}`
          )
          this.initiateSearch()
        } catch (error) {
          this.handleError(error)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
